/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusPrintoutDto } from './NovitusPrintoutDto';
import {
    NovitusPrintoutDtoFromJSON,
    NovitusPrintoutDtoFromJSONTyped,
    NovitusPrintoutDtoToJSON,
} from './NovitusPrintoutDto';

/**
 * 
 * @export
 * @interface NovitusNonFiscalPayloadDto
 */
export interface NovitusNonFiscalPayloadDto {
    /**
     * Dane wydruku niefiskalnego
     * @type {NovitusPrintoutDto}
     * @memberof NovitusNonFiscalPayloadDto
     */
    printout: NovitusPrintoutDto;
}

/**
 * Check if a given object implements the NovitusNonFiscalPayloadDto interface.
 */
export function instanceOfNovitusNonFiscalPayloadDto(value: object): value is NovitusNonFiscalPayloadDto {
    if (!('printout' in value) || value['printout'] === undefined) return false;
    return true;
}

export function NovitusNonFiscalPayloadDtoFromJSON(json: any): NovitusNonFiscalPayloadDto {
    return NovitusNonFiscalPayloadDtoFromJSONTyped(json, false);
}

export function NovitusNonFiscalPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusNonFiscalPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'printout': NovitusPrintoutDtoFromJSON(json['printout']),
    };
}

export function NovitusNonFiscalPayloadDtoToJSON(value?: NovitusNonFiscalPayloadDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'printout': NovitusPrintoutDtoToJSON(value['printout']),
    };
}

